<template>
    <div class="main-body">
        <h2>{{ $strings('spsite/sp/title') }}</h2>
        <div class="action-bar">
            <div class="add-wrapper">
                <el-button size="small" type="primary" @click="onCreate">{{ $strings('word/create') }}</el-button>
            </div>
            <div class="filter-wrapper">
                <el-form :inline="true" :model="formFilter" class="demo-form-inline" ref="filter">
                    <el-form-item label="">
                        <el-input v-model="formFilter.sp_name" :placeholder="$strings('word/sp_name')" size="small"
                                  class="max-width-120" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onFilter" size="small">{{
                                $strings('word/query')
                            }}
                        </el-button>
                        <el-button @click="onReset" size="small">{{ $strings('word/reset') }}</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="data-area">
            <el-table
                v-loading="loading"
                border
                :data="tableData"
                style="width: 100%">
                <el-table-column prop="sp_id" label="ID" width="100">
                    <template slot-scope="scope"><span class="code-text">{{ scope.row.sp_id }}</span></template>
                </el-table-column>
                <el-table-column prop="sp_name" label="Name" width="180"></el-table-column>
                <el-table-column prop="ct_time" label="CreateTime" width="160">
                    <template slot-scope="scope">
                        {{ convertUnixToDate(scope.row.ct_time) }}
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="Remark"></el-table-column>
                <el-table-column label="Edit" width="100">
                    <template slot-scope="scope">
                        <el-button size="small" @click="onEdit(scope.row)">Edit</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination margin-top-1" v-if="pagination.total > pagination.size" style="text-align: right">
                <el-pagination background layout="prev, pager, next" :total="pagination.total"
                               :page-size.sync="pagination.size"
                               :current-page.sync="pagination.page" @current-change="refreshData"></el-pagination>
            </div>
        </div>
        <el-dialog
            :title="isEdit ? $strings('word/edit') : $strings('word/create')"
            :visible.sync="dialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            @closed="onClose"
            width="30%">
            <div>
                <el-form ref="form" :model="editForm" label-width="80px" :rules="rules">
                    <el-form-item :label="$strings('spsite/sp/prop_sp')" prop="sp_name" v-if="!isEdit">
                        <el-input v-model="editForm.sp_name" clearable maxlength="8" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item :label="$strings('spsite/sp/prop_remark')" prop="remark">
                        <el-input v-model="editForm.remark" clearable maxlength="24" show-word-limit></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ $strings('word/cancel') }}</el-button>
                <el-button type="primary" @click="onSaveEdit()" :loading="saving">{{ $strings('word/confirm') }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {SpSiteSpCreate, SpSiteSpRead, SpSiteSpUpdate} from "@/api/spsite/api";
import {API_STATUS_CODE, STORAGE_KEY_LOGIN_TZ} from "@/config/config";
import {GetItem} from "@/utils/storage";
import {UnixToDateFull} from "../../../utils/time";

export default {
    name: "spsite-sp",
    data() {
        return {
            refreshing: false,
            loading: true,
            isEdit: false,
            saving: false,
            editForm: {},
            formFilter: {},
            tableData: [],
            dialogVisible: false,
            pagination: {
                total: 0,
                page: 1,
                size: 12,
            },
            rules: {
                remark: [
                    {required: true, message: this.$strings('spsite/sp/error/remark_empty'), trigger: 'blur'}
                ],
                sp_name: [
                    {required: true, message: this.$strings('spsite/sp/error/sp_name_empty'), trigger: 'blur'},
                    {min: 3, max: 8, message: this.$strings('spsite/cp/error/cp_name_empty'), trigger: 'blur'}
                ]
            }
        }
    },
    mounted() {
        this.refreshData();
    },
    computed: {},
    methods: {
        convertUnixToDate(ts) {
            let tz = parseInt(GetItem(STORAGE_KEY_LOGIN_TZ))
            return UnixToDateFull(ts, tz);
        },
        onFilter() {
            this.refreshData();
        },
        onReset() {
            this.formFilter = {};
            this.refreshData();
        },
        onClose() {
            this.saving = false
            this.$refs["form"].clearValidate();
        },
        onEdit(row) {
            this.isEdit = true;
            this.editForm = row;
            this.dialogVisible = true;
        },
        onCreate() {
            this.isEdit = false;
            this.editForm = {};
            this.dialogVisible = true;
        },
        onSaveEdit() {
            this.saving = true;
            let action = this.isEdit ? SpSiteSpUpdate : SpSiteSpCreate;
            action(this.editForm).then((resp) => {
                if (resp.data.code === API_STATUS_CODE.SUCCESS) {
                    this.dialogVisible = false;
                    this.isEdit = false;
                    this.refreshData();
                }
            });
        },
        refreshData() {
            this.loading = true;
            this.formFilter.size = this.pagination.size;
            this.formFilter.page = this.pagination.page;
            SpSiteSpRead(this.formFilter).then((resp) => {
                this.tableData = resp.data.data.count > 0 ? resp.data.data.rows : [];
                this.pagination.total = resp.data.data.count;
            }).finally(() => {
                this.loading = false;
            })
        },
    }
}
</script>

<style scoped lang="scss">
.action-bar {
    display: flex;
    flex-direction: row;

    .filter-wrapper {
        display: flex;
        justify-content: flex-end;
        flex-grow: 1;
    }

    .add-wrapper {
        padding-top: 4px;
    }
}

.table-pagination {
    margin-top: 1em;
    display: flex;
    justify-content: flex-end;
}
</style>